var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.806,
    height: 34.145,
    viewBox: "0 0 48.806 34.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 223",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 153",
    d: "M47.5,170.744a.592.592,0,0,0-.146-.429l-4.692-5.338a.592.592,0,0,0-.836-.054,24.411,24.411,0,0,0-5.32,6.643.592.592,0,0,0,.236.8l6.237,3.409a.592.592,0,0,0,.8-.236A16.14,16.14,0,0,1,47.3,171.15.59.59,0,0,0,47.5,170.744Z",
    transform: "translate(-33.527 -158.965)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 154",
    d: "M162.233,102.942a.592.592,0,0,0,.8.246,15.949,15.949,0,0,1,5.345-1.719.592.592,0,0,0,.507-.667l-.955-7.043a.593.593,0,0,0-.667-.507,24.212,24.212,0,0,0-8.116,2.611.592.592,0,0,0-.246.8Z",
    transform: "translate(-146.166 -93.14)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 155",
    d: "M8.436,312.63l-6.86-1.861a.593.593,0,0,0-.727.417,24.467,24.467,0,0,0-.85,6.4c0,.371.009.744.027,1.139a.592.592,0,0,0,.591.565H.646l7.1-.328a.592.592,0,0,0,.564-.619c-.012-.266-.018-.514-.018-.756a16.167,16.167,0,0,1,.561-4.232A.593.593,0,0,0,8.436,312.63Z",
    transform: "translate(0 -293.298)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 156",
    d: "M328.611,94.221a24.222,24.222,0,0,0-8.208-2.3.592.592,0,0,0-.647.532l-.685,7.075a.592.592,0,0,0,.532.647,15.956,15.956,0,0,1,5.407,1.512.592.592,0,0,0,.791-.276l3.086-6.4A.592.592,0,0,0,328.611,94.221Z",
    transform: "translate(-293.623 -91.922)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 157",
    d: "M441.7,164.378a.592.592,0,0,0-.066-.449,24.421,24.421,0,0,0-5.57-6.435.592.592,0,0,0-.833.086L430.75,163.1a.593.593,0,0,0,.086.833,16.15,16.15,0,0,1,3.685,4.256.592.592,0,0,0,.812.2l6.1-3.647A.594.594,0,0,0,441.7,164.378Z",
    transform: "translate(-396.277 -152.144)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 158",
    d: "M506.42,300.145a.592.592,0,0,0-.742-.388l-6.782,2.125a.592.592,0,0,0-.388.742,16.118,16.118,0,0,1,.734,4.824c0,.243-.006.49-.018.756a.592.592,0,0,0,.564.619l7.1.328h.028a.592.592,0,0,0,.591-.565c.018-.4.027-.768.027-1.139A24.4,24.4,0,0,0,506.42,300.145Z",
    transform: "translate(-458.727 -283.157)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 159",
    d: "M180.576,314.37c-.1,0-.2,0-.3.009l-9.622-5.677a.61.61,0,0,0-.848.812l5.249,9.837a5.661,5.661,0,0,0-.03.574,5.555,5.555,0,1,0,5.555-5.555Z",
    transform: "translate(-156.194 -291.336)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedMeter);
export default __webpack_public_path__ + "static/media/speed-meter.5e79b06d.svg";
export { ForwardRef as ReactComponent };